<template>
  <div>
    <v-filter>
      <el-form inline slot="filter" :model="filter" @submit.native.prevent="loadList()">
        <el-form-item label="姓名">
          <el-input v-model="filter.name"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="edit()">新增类目</el-button>
    </v-filter>

    <el-table :data="list" stripe row-key="id">
      <el-table-column prop="order" label="排序" width="100px">
        <!-- <template slot-scope="scope">
          <edit-table-input
           :row="scope.row"
           edit-field="order"
           @change="changeOrder(scope.row)">
          </edit-table-input>
        </template> -->
      </el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column width="100px">
        <div slot-scope="scope">
          <el-button
           type="text"
           @click="edit(scope.row)">编辑</el-button>
          <el-button
           type="text"
           @click="del(scope.row.id)">删除</el-button>
        </div>
      </el-table-column>
    </el-table>
    
    <v-page v-model="filter" @change="loadList"></v-page>

    <el-drawer
     :title="`${!form.id ? '新增' : '编辑'}途径`"
     :visible.sync="visible"
     direction="rtl">
      <el-form
       :model="form"
       ref="form"
       :rules="rules"
       label-width="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="排序" prop="order">
          <el-input v-model="form.order"></el-input>
        </el-form-item>

        <!-- <el-form-item label="简介" prop="desc">
          <el-input v-model="form.desc" type="textarea" :rows="3"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button>重置</el-button>
          <el-button
           type="primary"
           @click="commit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'MainBusinessTypes',
  data() {
    return {
      visible: false,
      filter: {
        page: 1,
        page_size: 10
      },

      list: [],
      total: 0,

      form: {},
      rules: {
        name: [{ required: true, message: '必填！', trigger: 'blur' }],
        order: [{ required: true, message: '必填！', trigger: 'blur' }],
        desc: [{ required: true, message: '必填！', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.$init(['form'], () => {
      this.loadList()
    })
  },
  methods: {
    edit(row = {}) {
      this.$reset(['form'], async () => {
        if (row.id) {
          this.$sets(this.form, row)
        }
        this.visible = true
      })
    },

    async del(id) {
      await this.$confirm('确认删除？')
      await this.$api.store.mainBusinessTypes.deleting(id)
      this.$message.success('删除成功！')
      this.loadList()
    },

    async loadList(page = 1) {
      this.filter.page = page
      const { data } = await this.$api.store.mainBusinessTypes.gettings(this.filter)
      this.list = data.items
      this.filter.total = data.totalItems
    },

    async changeOrder(row) {
      try {
        const { id, order } = row
        await this.$api.store.mainBusinessTypes.putOrder(id, order)
      } catch (e) {
        this.loadList()
      }
    },

    async commit() {
      await this.$validate(this.$refs.form)
      const params = { ...this.form }
      if (!params.id) {
        await this.$api.store.mainBusinessTypes.posting(params)
      } else {
        await this.$api.store.mainBusinessTypes.putting(params.id, params)
      }

      await this.loadList()
      this.$message.success('保存成功！')
      this.visible = false
    }
  }
}
</script>
